import { render, staticRenderFns } from "./WardManager.vue?vue&type=template&id=553c4f9d&"
import script from "./WardManager.vue?vue&type=script&lang=js&"
export * from "./WardManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports